var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable } from '../../../../Data/Decorators/Injectable';
import { inject } from '../../../../Data/Decorators/Inject';
import { ICoordinatorServiceType } from '../../../Services/CoordinatorService/ICoordinatorService';
import { ILocalizationRepositoryType } from '../../Localization/ILocalizationRepository';
import { Platform } from 'react-native';
let ImportUseCase = class ImportUseCase {
    constructor(coordinatorService, localizationRepository) {
        this.coordinatorService = coordinatorService;
        this.localizationRepository = localizationRepository;
    }
    execute(options) {
        return new Promise((res, rej) => {
            let interactions = [];
            const text = this.localizationRepository.getImportLocalization();
            if (Platform.OS === 'web') {
                this.coordinatorService.launchGallery(options)
                    .then(res)
                    .catch(error => {
                    rej(error);
                    return Promise.reject(error);
                });
                return;
            }
            else {
                interactions = [
                    {
                        type: 'secondary',
                        action: 'camera',
                        text: text.camera,
                        onPress: () => {
                            this.coordinatorService.hidePopUp();
                            return this.coordinatorService.launchCamera(options)
                                .then(res)
                                .catch(error => {
                                this.coordinatorService.showError({
                                    description: error.message,
                                    interactions: [
                                        {
                                            action: 'ok',
                                            type: 'primary',
                                            text: 'Ok',
                                            onPress: () => this.coordinatorService.hideError()
                                        }
                                    ]
                                });
                                rej(error);
                                return Promise.reject(error);
                            });
                        }
                    },
                    {
                        type: 'primary',
                        action: 'gallery',
                        text: text.gallery,
                        onPress: () => {
                            this.coordinatorService.hidePopUp();
                            return this.coordinatorService.launchGallery(options)
                                .then(res)
                                .catch(error => {
                                this.coordinatorService.showError({
                                    description: error.message,
                                    interactions: [
                                        {
                                            action: 'ok',
                                            type: 'primary',
                                            text: 'Ok',
                                            onPress: () => this.coordinatorService.hideError()
                                        }
                                    ]
                                });
                                rej(error);
                                return Promise.reject(error);
                            });
                        }
                    }
                ];
            }
            const params = {
                title: options === null || options === void 0 ? void 0 : options.title,
                description: (options === null || options === void 0 ? void 0 : options.description) || text.description || 'Where do you want to get photos to attach?',
                interactions
            };
            this.coordinatorService.showPopUp(params);
        });
    }
};
ImportUseCase = __decorate([
    injectable(),
    __param(0, inject(ICoordinatorServiceType)),
    __param(1, inject(ILocalizationRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], ImportUseCase);
export { ImportUseCase };
